module.exports = __webpack_public_path__ + "static/img/wk.7032930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wk.png
// module id = OA9e
// module chunks = 1